import {RiskModel} from "@/services/ModelRisk/RiskModel";

export class RuleService {
    async getByGroupId(groupId) {
        let result = await fetch(`${RiskModel.endpoint}/rule?group_id=${groupId}`)
        return await result.json();
    }
}
